import React from "react";

const OraclesFace = () => {
  return (
    <div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ color: "#00ffff", borderBottom: "2px solid #00ffff", paddingBottom: "10px" }}>
        🔮 Blockchain Oracles
      </h2>
      <p style={{ marginTop: "15px", opacity: 0.9 }}>
        Conexión de contratos inteligentes con datos del mundo real de manera segura, utilizando soluciones descentralizadas de Oracle.
      </p>
      <div style={{ marginTop: "20px" }}>
        <h3 style={{ color: "#00ffff", fontSize: "16px" }}>Implementación:</h3>
        <ul style={{ fontSize: "14px", opacity: 0.8 }}>
          <li>Data Feeds para precios de activos en tiempo real.</li>
          <li>Generación de números aleatorios (VRF) para Gaming/NFTs.</li>
          <li>Automation de contratos mediante Keepers/Upkeeps.</li>
        </ul>
      </div>
      <div style={{ marginTop: "25px", padding: "15px", background: "rgba(0, 255, 255, 0.1)", borderRadius: "12px", border: "1px dashed #00ffff" }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#00ffff", fontSize: "14px" }}>🚀 Producto de FrancoLab:</h4>
        <p style={{ fontSize: "13px", margin: "0 0 10px 0" }}>
          <strong>FrancoNode:</strong> Un nodo descentralizado que provee datos climáticos para seguros agrícolas en cadena.
        </p>
        <a href="#" style={{ color: "#00ffff", fontSize: "13px", fontWeight: "bold", textDecoration: "none" }}>Ver Docs Técnicas →</a>
      </div>
    </div>
  );
};

export default OraclesFace;